import React from 'react';

import { AuthenticatedRoute } from '@/console/app/protected-route/authenticated-route';
import {
  MainContainer,
  RootContainer,
} from '@/console/app/routes/root/root.styled';
import { TErrorBoundaryRouteProps } from '@/shared/app/routes/error-boundary/error-boundary.types';
import { RouteErrorContent } from '@/shared/features/error/components/route-error-content/route-error-content';
import { Header } from '@/shared/features/header/header';

export const ErrorBoundaryRoute: React.FC<TErrorBoundaryRouteProps> = ({
  sidebar,
  headerProps,
}) => {
  return (
    <AuthenticatedRoute>
      <RootContainer>
        {sidebar}
        <MainContainer>
          <Header {...headerProps} hideBreadcrumbs />
          <RouteErrorContent />
        </MainContainer>
      </RootContainer>
    </AuthenticatedRoute>
  );
};
